module.exports = __webpack_public_path__ + "static/media/sidebar-customer-management-selected.df0a9ae6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-customer-management-selected.svg
// module id = 798
// module chunks = 0